import { debounce } from '@/utils/tools'
import QueryEncoder from '@/utils/Encoders/QueryEncoder'

/**
 * This is the global encoder it works like a singleton that keeps track of a the global query
 * and will then update the it when changes get recorded the in push function
 *
 * @type {{_state: [], forceUpdateHistory(): void, push(*=): void, updateHistory: function()}}
 */
export default (() => {
  if (window._globalEncoder) return window._globalEncoder

  const encoder = {
    _state: [],

    /**
     * @description
     *  This method pushes a new update to the query queue
     * @param update {key: {string}, query: {string}}
     */
    push(update = { key: '', query: '' }) {
      this._state.push(update)
      this.updateHistory()
    },
    /**
     * @description
     *  This method runs through the query queue and creates a final new query update that will then replace the current
     *  history. To activate pop and push histories just replace replaceState with pushState
     */
    forceUpdateHistory() {
      const l = window.location
      const query = QueryEncoder.decodeQueryIntoObject(l.search)

      let update = {}
      // We update our query with our new state changes
      // eslint-disable-next-line no-cond-assign
      while ((update = this._state.pop())) {
        query[update.key] = update.query
      }

      const newQuery = Object.keys(query)
        .map((k) => `${k}=${query[k]}`)
        .join('&')
      const { hash } = window.location
      const url = `${l.origin}${l.pathname}?${newQuery}${hash || ''}`
      window.history.replaceState(query, '', url)
      // We empty our state
      this._state = []
    },
    // This is a debounce version of the forceUpdateHistory function
    updateHistory: () => {},
  }

  encoder.updateHistory = debounce(encoder.forceUpdateHistory.bind(encoder), 2)

  window._globalEncoder = encoder

  return window._globalEncoder
})()
